import apiClient from "../client";

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

export const getLocations = async () => {
  try {
    const res = await apiClient.get(`${API_BASE_URL}/intron/job/locations`);
    return res?.data?.data?.items || [];
  } catch (error) {
    console.error("Error fetching locations:", error);
    return [];
  }
};
